import { POSTHOG_PAGE_REFER } from 'common/constants';

const DEPOSIT_PATH_SEGMENT = '/deposit';

const normalizePath = pageRefer => {
  if (typeof pageRefer !== 'string') return null;

  const [path] = pageRefer.split(/[?#]/);

  let end = path.length;
  while (end > 0 && path[end - 1] === '/') end -= 1;

  return path.slice(0, end) || '/';
};

export const getDepositPageRefer = pageRefer => {
  if (pageRefer === POSTHOG_PAGE_REFER.ALTERNATIVE_PAYMENT_METHOD_POP_UP) {
    return pageRefer;
  }

  const path = normalizePath(pageRefer);

  if (!path) return null;

  if (path === '/casino' || path.startsWith('/casino/')) {
    return POSTHOG_PAGE_REFER.CASINO;
  }

  if (
    path === '/promo' ||
    path.startsWith('/promo/') ||
    path === '/promotions' ||
    path.startsWith('/promotions/')
  ) {
    return POSTHOG_PAGE_REFER.PROMO;
  }

  if (path === '/bonuses' || path.startsWith('/bonuses/') || path.includes('/bonuses')) {
    return POSTHOG_PAGE_REFER.BONUSES;
  }

  if (path.includes(DEPOSIT_PATH_SEGMENT)) {
    return null;
  }

  return path;
};
